import { giphyLightCharcoal } from '@giphy/js-brand'
import React from 'react'

export type IconProps = {
    className?: string
}

export const GifIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" className={className}>
        <path
            d="M20 0a6 6 0 016 6v14a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6h14zM7.928 9C5.196 9 3.95 10.933 3.95 12.815S5.04 16.6 7.918 16.6c1.402 0 2.67-.494 3.127-1.409v-3.198H7.492v1.594h1.839v.925c-.416.299-1.018.37-1.403.37-1.464 0-1.952-1.141-1.952-2.067 0-1.409.768-2.108 1.952-2.108.489 0 1.133.134 1.662.628l1.195-1.173C9.829 9.206 8.936 9 7.928 9zm6.673.206h-2.047v7.199h2.047v-7.2zm7.399 0h-5.578v7.199h2.036v-2.479h3.324V12.26h-3.324v-1.347H22V9.206z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const StickerIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" className={className}>
        <path
            d="M12.384 0c6.15 0 11.25 4.338 12.216 10.022-1.322-.518-2.876-1.035-4.389-1.035-6.306 0-11.589 4.75-11.09 11.097.09 1.162.689 2.774 1.035 3.83C4.744 22.63 0 17.611 0 11.98 0 5.364 5.545 0 12.384 0zm11.233 11.44L11.92 23.012c-.504-1.082-.893-2.339-.893-3.603 0-2.898.97-4.821 2.564-6.303 1.382-1.284 3.084-2.185 5.632-2.4 1.555-.13 3.048.182 4.394.734z"
            fill="#FFF"
            fillRule="nonzero"
        />
    </svg>
)

export const VideoIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" className={className}>
        <path
            d="M18.48 0a6.72 6.72 0 016.72 6.72v11.76a6.72 6.72 0 01-6.72 6.72H6.72A6.72 6.72 0 010 18.48V6.72A6.72 6.72 0 016.72 0zm-5.043 7.321a.405.405 0 00-.573-.002l-2.58 2.56H6.705a.405.405 0 00-.405.405v4.77c0 .224.181.405.405.405h2.832l3.327 3.321a.405.405 0 00.69-.286V7.606a.405.405 0 00-.117-.285zm3.645 1.244a.608.608 0 00-.826.217.594.594 0 00.22.817 4.174 4.174 0 012.115 3.625 4.174 4.174 0 01-2.107 3.62.594.594 0 00-.219.818.608.608 0 00.827.216 5.367 5.367 0 002.708-4.654 5.368 5.368 0 00-2.718-4.66zm-1.656 1.571a.608.608 0 00-.805.284.595.595 0 00.286.796 1.792 1.792 0 011.037 1.621 1.79 1.79 0 01-.916 1.56.594.594 0 00-.225.815.608.608 0 00.825.222 2.982 2.982 0 001.525-2.597c0-1.165-.68-2.21-1.727-2.7z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const TextIcon = ({ className }: IconProps) => (
    <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 40 40">
        <path
            d="M19.68 8.16c6.54 0 11.84 5.3 11.84 11.84v11.84H19.68c-6.54 0-11.84-5.3-11.84-11.84s5.3-11.84 11.84-11.84zm4.474 8.48l-1.844.205v1.561h-1.126v1.536h1.126v2.381c0 1.971 1.037 2.573 2.407 2.509.499-.026.87-.102 1.331-.282l-.422-1.536c-.205.103-.55.154-.768.154-.346 0-.717-.18-.717-.845v-2.38h1.613v-1.537h-1.6V16.64zm-2.917-.992H13.8v1.78h2.726v7.18h1.984v-7.18h2.727v-1.78z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const BackdropIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 39" className={className}>
        <path
            d="M56 0a6 6 0 016 6v27a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6h50zM31.5 10c-.913 0-1.786.178-2.616.534a6.8 6.8 0 00-2.155 1.444 6.801 6.801 0 00-1.444 2.155 6.576 6.576 0 00-.534 2.617c0 1.151.121 2.274.363 3.368.242 1.095.512 1.982.81 2.663.3.682.642 1.328 1.029 1.938.386.611.657 1.007.81 1.187.154.18.275.314.363.402 0 .607-.187 1.145-.56 1.615-.374.47-.857.86-1.45 1.167-.593.307-1.25.6-1.971.877-.72.276-1.441.566-2.162.87-.72.303-1.377.64-1.97 1.008a4.53 4.53 0 00-1.45 1.437 3.64 3.64 0 00-.554 1.779l-.007.252v1.12c0 .14-.024.48.082.553l.046.014h26.735c.105 0 .13-.182.134-.35v-1.337c0-.765-.187-1.442-.56-2.03a4.53 4.53 0 00-1.45-1.438c-.594-.369-1.25-.705-1.971-1.008a74.008 74.008 0 00-2.162-.87c-.72-.277-1.378-.57-1.97-.877a4.413 4.413 0 01-1.45-1.167 2.51 2.51 0 01-.554-1.415l-.007-.2.185-.198c.123-.131.283-.338.48-.62.198-.28.418-.612.66-.995.241-.382.483-.848.725-1.397.241-.55.461-1.132.659-1.747.198-.615.358-1.325.481-2.13.123-.803.185-1.627.185-2.471 0-.914-.178-1.786-.534-2.617a6.801 6.801 0 00-1.444-2.155 6.8 6.8 0 00-2.155-1.444A6.573 6.573 0 0031.5 10zM7.8 6a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zm5.4 0a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6zm5.4 0a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const SuperCutIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 32" className={className}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M34.1 11.5a2.1 2.1 0 00-2.1 2.1v2.8c0 1.16.94 2.1 2.1 2.1h16.8a2.1 2.1 0 002.1-2.1v-2.8a2.1 2.1 0 00-2.1-2.1H34.1zm7 1.4h2.8a.7.7 0 01.7.7v2.8a.7.7 0 01-.7.7h-2.8a.7.7 0 01-.7-.7v-2.8a.7.7 0 01.7-.7zm6.3 0h2.8a.7.7 0 01.7.7v2.8a.7.7 0 01-.7.7h-2.8a.7.7 0 01-.7-.7v-2.8a.7.7 0 01.7-.7zm-12.6 0h2.8a.7.7 0 01.7.7v2.8a.7.7 0 01-.7.7h-2.8a.7.7 0 01-.7-.7v-2.8a.7.7 0 01.7-.7z"
                fill="#FFF"
            />
            <path
                d="M3.9 11.59C1.235 9.353.686 5.62 2.674 3.25 4.662.881 8.434.774 11.1 3.01c2.665 2.237 3.214 5.97 1.226 8.34-1.988 2.369-5.76 2.476-8.426.24z"
                stroke="#FFF"
                strokeWidth="2.1"
            />
            <path
                fill="#FFF"
                d="M17.616 17.424l15.316 9.339H38.3L20.623 15.7zM8.579 17.85L33.991 2.017H38.3L11.626 19.35l-2.133-1.817z"
            />
            <path
                d="M3.9 19.81c-2.665 2.237-3.214 5.97-1.226 8.34 1.988 2.369 5.76 2.476 8.426.24 2.665-2.237 3.214-5.97 1.226-8.34-1.988-2.369-5.76-2.476-8.426-.24z"
                stroke="#FFF"
                strokeWidth="2.1"
            />
        </g>
    </svg>
)

export const EraseIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M195.34 55.325c1.79-.056 3.555.232 5.207.831 2.367.52 4.63 1.663 6.532 3.435l44.553 41.547c5.655 5.273 5.964 14.132.68 19.799l-71.11 75.028h63.756a4 4 0 01.213 7.995l-.213.006-71.229-.001-.137.165h-29.525a14.002 14.002 0 01-9.614-3.823l-40.682-38.43c-6.795-6.418-7.134-17.116-.76-23.952L165.306 60.4a14 14 0 019.804-4.446zm-44.847 44.418l-11.307.394-40.324 43.244a9 9 0 00.194 12.478l.208.203 40.683 38.43a6 6 0 004.12 1.638l2.582-.002a3.99 3.99 0 01.921-.157l.213-.005 9.83-.001-44.502-39.636c-4.459-3.97-4.924-10.755-1.074-15.326l.206-.238.14-.152 38.11-40.87zm7.185 4.026l-39.491 42.35a3.001 3.001 0 00.244 4.237l47.159 42.002a6.002 6.002 0 006.708.87l35.7-42.536-50.32-46.923z"
                fill="#E646B6"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const PaintIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M221.597 54.228c6.911-7.672 18.712-8.309 26.358-1.423.166.15.33.302.49.457 7.493 7.255 7.667 19.232.388 26.753l-.25.253-70.861 70.522.111.288-7.688 7.253-10.882 10.831a26.71 26.71 0 01-6.163 18.804l-.273.32c-9.573 11.047-22.494 18.895-35.693 22.57-12.342 3.437-23.447 2.768-28.356-2.496-2.94-3.153-3.92-6.263-1.558-9.233.76-.956 1.682-1.61 3.006-2.325l.505-.262 2.36-1.177.41-.21c5.089-2.66 8.224-5.833 10.396-12.048l1.2-3.41.93-2.603.872-2.399.662-1.78.633-1.664.607-1.555.442-1.099.288-.7.424-1.009.415-.957.409-.91.403-.864.266-.553.265-.534.396-.77.263-.493.264-.479.264-.463.264-.45.267-.438.268-.426.27-.415.273-.404.277-.395.28-.387.283-.379.434-.555.295-.363.301-.357.307-.354.472-.525.488-.52.334-.345.517-.519.356-.347.55-.524.473-.437c5.089-4.583 11.86-6.42 18.39-5.688zm-74.459 105.763c-5.854-6.3-16.293-6.926-22.409-1.204l-.3.284-.58.563-.416.42-.402.422-.389.427-.378.433-.246.295-.362.452-.237.309-.234.316-.345.49-.228.337-.226.348-.225.36-.335.56-.224.389-.223.403-.224.417-.225.433-.226.45-.342.705-.347.746-.354.79-.361.835-.371.885-.381.936-.527 1.333-.55 1.437-.579 1.546-.766 2.097-.99 2.772-.714 2.04c.76 3.008 2.762 4.79 6.005 5.343 5.037.86 7.558 4.406 7.561 10.637 7.73-3.781 14.953-9.183 20.75-15.9 5.823-6.749 6.026-17.052.4-23.106zm10.535-21.091l-9.826 10.373a5.752 5.752 0 00-.2.222l-.188.232c-.064.085-.127.17-.186.257a23.597 23.597 0 015.817 4.538 22.533 22.533 0 013.313 4.602 8.68 8.68 0 003.34-1.968l4.849-4.576 3.729-3.711-.037-.085c-1.351-3.053-2.696-5.288-3.976-6.69l-.191-.203-.174-.175c-1.252-1.227-3.316-2.192-6.235-2.808l-.035-.008zm84.915-80.136c-4.367-3.931-11.105-3.567-15.051.813l-65.125 72.298c2.913.95 5.3 2.306 7.142 4.11 1.711 1.676 3.296 3.967 4.794 6.887l68.67-68.343.272-.286c3.994-4.347 3.829-11.1-.423-15.218l-.28-.261z"
                fill="#0F9"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const LassoIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M122.308 188.824a23.465 23.465 0 007.986.911c-1.16 5.792-3.067 10.754-5.98 15.092-5.305 7.894-13.655 13.03-25.436 15.111a4 4 0 01-4.633-3.251 4.008 4.008 0 013.245-4.644c14.786-2.611 22-10.071 24.818-23.219zm6.629-39.134c9.112 0 16.5 7.403 16.5 16.534 0 9.132-7.388 16.535-16.5 16.535-9.113 0-16.5-7.403-16.5-16.535 0-9.131 7.387-16.534 16.5-16.534zM173 59c49.361 0 90 25.872 90 59.124s-40.639 59.124-90 59.124c-7.728 0-15.242-.635-22.42-1.832a23.52 23.52 0 001.848-9.849c6.553 1.081 13.447 1.66 20.572 1.66 44.527 0 80-22.583 80-49.103 0-26.52-35.473-49.103-80-49.103s-80 22.583-80 49.103c0 11.918 7.164 23.041 19.095 31.677a23.566 23.566 0 00-5.302 8.521C92.049 147.862 83 133.814 83 118.124 83 84.872 123.639 59 173 59z"
                fill="#93F"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const MagicWandIcon = ({ className }: IconProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 345 345">
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h345v345H0z" />
            <path
                d="M215.524 76.13l6.29 6.29c4.684 4.684 4.68 12.281-.007 16.969L121.72 199.474c-4.688 4.688-12.285 4.691-16.968.008l-6.29-6.29c-4.684-4.684-4.68-12.281.007-16.969L198.556 76.138c4.687-4.688 12.284-4.691 16.968-.008zm-36.998 31.344l-74.402 74.403a4 4 0 00-.003 5.656l6.29 6.29a4 4 0 005.656-.002l74.397-74.398-11.938-11.949zm74.487-6.458c.221 23.277 12.238 23.985 12.959 24.006h.034c-12.993 0-12.993 24.008-13.012 24.008l-.003-.713c-.255-23.294-12.971-23.294-12.971-23.294 12.603 0 12.981-22.588 12.992-23.944zm-2.999-79.024c.293 28.416 16.33 28.997 16.971 29.008h.02c-16.99 0-16.99 29.01-17.015 29.01 0-28.43-16.294-28.998-16.946-29.01h-.02c16.65 0 16.984-27.86 16.99-28.974zm-82.954 4.026l.01.599c.463 19.962 12.483 20.374 12.968 20.382h.015c-12.993 0-12.993 21.007-13.011 21.007 0-20.586-12.46-20.998-12.96-21.006h-.015c12.603 0 12.982-19.765 12.993-20.951v-.031z"
                fill="#0CF"
                fillRule="nonzero"
            />
        </g>
    </svg>
)

export const NewIcon = ({ className }: IconProps) => (
    <svg
        width="48"
        height="30"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={className}
    >
        <defs>
            <filter
                x="-22.4%"
                y="-32.5%"
                width="144.7%"
                height="185%"
                filterUnits="objectBoundingBox"
                id="newiconshadow"
            >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" in="shadowBlurOuter1" />
            </filter>
            <path
                d="M36 0a2 2 0 012 2v16a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h34zM18.946 8.072c-.576 0-.576 0-1.086.204-.51.204-.51.204-.894.588s-.384.384-.606.948c-.222.564-.222.564-.222 1.296 0 .78 0 .78.228 1.344.228.564.228.564.618.942s.39.378.906.558c.516.18.516.18 1.092.18.876 0 .876 0 1.524-.306.567-.268.567-.268 1.015-.88l.125-.182-1.164-.708c-.36.504-.36.504-.696.654-.336.15-.336.15-.756.15-.48 0-.48 0-.87-.324-.341-.284-.341-.284-.43-.88l-.02-.176h3.948c-.024-1.716-.024-1.716-.762-2.562-.738-.846-.738-.846-1.95-.846zM9.958 5.996H8.302V14h1.596V8.708L13.378 14h1.416V5.996h-1.596v4.992l-3.24-4.992zm13.692 2.22h-1.632L24.082 14h1.14l1.092-3.348L27.418 14h1.14l2.064-5.784H28.99l-1.044 3.48-1.152-3.48h-.96l-1.14 3.48-1.044-3.48zM18.946 9.26c.384 0 .384 0 .726.288.342.288.342.288.39.864h-2.316c.036-.264.036-.264.15-.48.114-.216.114-.216.282-.366.168-.15.168-.15.366-.228.198-.078.198-.078.402-.078z"
                id="newiconpath"
            />
        </defs>
        <g transform="translate(5 3)" fill="none" fillRule="evenodd">
            <use fill="#000" filter="url(#newiconshadow)" xlinkHref="#newiconpath" />
            <use fill="#FFF" xlinkHref="#newiconpath" />
        </g>
    </svg>
)

export const CheckIcon = ({ className }: IconProps) => (
    <div className={className} style={{ height: 16, width: 16 }}>
        <svg
            width="40"
            height="40"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{ height: 40, width: 40, margin: '-10px -12px -14px' }}
        >
            <defs>
                <filter
                    x="-118.8%"
                    y="-106.2%"
                    width="337.5%"
                    height="337.5%"
                    filterUnits="objectBoundingBox"
                    id="checkiconshadow"
                >
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur stdDeviation="6" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowBlurOuter1" />
                </filter>
                <path
                    d="M430 279a8 8 0 110 16 8 8 0 010-16zm3.33 4a.19.19 0 00-.15.067l-4.429 5.049-1.931-2.208a.19.19 0 00-.15-.067.19.19 0 00-.148.067l-1.459 1.659a.235.235 0 00-.063.169c0 .068.021.125.063.17l3.537 4.027c.055.045.106.067.151.067.046 0 .096-.022.151-.067l6.035-6.869a.235.235 0 00.063-.17.235.235 0 00-.063-.168l-1.459-1.66a.19.19 0 00-.149-.066z"
                    id="checkiconpath"
                />
            </defs>
            <g transform="translate(-410 -269)" fill="none" fillRule="evenodd">
                <use fill="#000" filter="url(#checkiconshadow)" xlinkHref="#checkiconpath" />
                <use fill="#FFF" xlinkHref="#checkiconpath" />
            </g>
        </svg>
    </div>
)

export const BackArrowIcon = ({ className }: IconProps) => (
    <svg className={className} width="30" height="30" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fillRule="nonzero">
            <path d="M18.758 25.178a1 1 0 101.364-1.462L9.798 14.013c-.404-.376-1.112-.354-1.49.05a1 1 0 00.05 1.413l10.4 9.702z" />
            <path d="M9.722 15.476a1 1 0 01-1.364-1.463l10.4-9.702a1 1 0 011.364 1.463l-10.4 9.702z" />
        </g>
    </svg>
)

export const PauseIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20" className={className}>
        <path
            d="M3.567 19.067H.817a.75.75 0 01-.75-.75V1.683a.75.75 0 01.75-.75h2.75a.75.75 0 01.75.75v16.634a.75.75 0 01-.75.75zm11.05 0h-2.75a.75.75 0 01-.75-.75V1.683a.75.75 0 01.75-.75h2.75a.75.75 0 01.75.75v16.634a.75.75 0 01-.75.75z"
            fill="#FFF"
            fillRule="evenodd"
        />
    </svg>
)

export const HandIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 30" className={className}>
        <path
            d="M22.4 26.842H20V30H8v-3.158h-.8l-.001-2.369H4.8l-.001-3.158H3.2l-.001-3.158H1.6v-1.579H0v-3.157h3.2V15h1.6v1.578h1.6V0h3.2v13.421h1.6V7.105h3.2l-.001 6.316H16V8.684h3.2L19.199 15H20.8v-3.947h1.6v1.579H24v11.842h-1.6v2.368z"
            fill={giphyLightCharcoal}
            fillRule="evenodd"
        />
    </svg>
)

export const StaircaseIcon = ({ className }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 67" className={className}>
        <path fill="#FFF" d="M44.667 44.667V22.333H22.333V0H0v67h67V44.667z" fillRule="evenodd" />
    </svg>
)
